// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5MCQwpBGx{display:flex;flex:1;height:100%;justify-content:center;background-color:white}._4Df91KEux{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px;text-align:center}._3aaRf8SUx{margin:20px 0px 8px 0px}._4fLX2RrZx{border:4px solid #137ad4;border-top:4px solid white;border-radius:50%;width:36px;height:36px;-webkit-animation:ALU6zRVsx 1s linear infinite;animation:ALU6zRVsx 1s linear infinite}@-webkit-keyframes ALU6zRVsx{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes ALU6zRVsx{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_5MCQwpBGx",
	"content": "_4Df91KEux",
	"title": "_3aaRf8SUx",
	"spinner": "_4fLX2RrZx",
	"load": "ALU6zRVsx"
};
module.exports = exports;
